import { useState, useCallback, useEffect } from 'react';
import {
  DEFAULT_FILTER_TYPE,
  LABEL_FILTER_ACTIVE,
  buildQueryString,
} from '../utils/certificados.utils';

export const useCertificadosFilter = ({ fetchData }) => {
  const [searchText, setSearchText] = useState('');
  const [checkFilter, setCheckFilter] = useState(DEFAULT_FILTER_TYPE);
  const [isClearFilter, setIsClearFilter] = useState(false);
  const [isListService, setIsListService] = useState(false);
  const [listModel, setListModels] = useState('');
  const [clienteCpf, setClienteCpf] = useState('');

  const isNotEmpty = useCallback((value) => Boolean(value?.trim()), []);

  useEffect(() => {
    if (checkFilter.type === 'CPF') {
      setClienteCpf(searchText);
    }
  }, [checkFilter, searchText]);

  const handleSearchType = useCallback(
    (setFilter, setTags, resetSelection, checked) => {
      if (!isNotEmpty(searchText) || checkFilter.index === undefined) return;

      const isTypeCpf = checked.index === 0;

      resetSelection();
      setIsClearFilter(false);
      setIsListService(true);

      setFilter((current) => ({
        ...current,
        tipoBusca: checked.type,
        filter: isTypeCpf ? searchText.replace(/\D/g, '') : searchText,
      }));

      setTags((currentTags) => {
        const TAG_PREFIXES = ['CPF', 'Cód', 'Nom'];
        const filtered = currentTags.filter(
          ({ label }) =>
            !TAG_PREFIXES.some((prefix) => label.startsWith(prefix)),
        );

        const newTag = {
          label: `${LABEL_FILTER_ACTIVE[checked.type]}: ${searchText}`,
          onClose: () => {
            setTags((tags) => {
              const remaining = tags.filter(
                (tag) =>
                  !tag?.label?.startsWith(LABEL_FILTER_ACTIVE[checked.type]),
              );
              setIsClearFilter(!remaining.length);
              setCheckFilter(DEFAULT_FILTER_TYPE);
              setSearchText('');
              return remaining;
            });

            fetchData({
              filter: { tipoBusca: '', filter: '', cpf: '' },
              sort: { type: 'DESC', field: 'dataConclusao' },
            });
            resetSelection();
          },
        };

        return [...filtered, newTag];
      });
    },
    [checkFilter, fetchData, isNotEmpty, searchText],
  );

  const handleOnClearFilter = useCallback(() => {
    setCheckFilter(DEFAULT_FILTER_TYPE);
    setSearchText('');
    setListModels('');
    setIsClearFilter(true);
    setIsListService(false);
    fetchData({
      sort: { field: 'dataConclusao', type: 'DESC' },
      filter: { filter: '', tipoBusca: '', cpf: '', listaModelos: '' },
    });
  }, [fetchData]);

  const getQueryString = useCallback(
    () => buildQueryString({ searchText, checkFilter, listModel }),
    [searchText, checkFilter, listModel],
  );

  return {
    searchText,
    setSearchText,
    checkFilter,
    setCheckFilter,
    isClearFilter,
    isListService,
    setIsListService,
    listModel,
    setListModels,
    clienteCpf,
    handleSearchType,
    handleOnClearFilter,
    getQueryString,
  };
};
